module.exports = __webpack_public_path__ + "img/nuggets.32386d40.png";